import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';
export const subjectTrackingDetailsAPI = createApi({
  baseQuery,
  reducerPath: 'subjectTrackingDetailsAPI',
  endpoints: builder => ({
    getDataReviewcrfSummary: builder.query<any, any>({
      query: ({ study_id, subject_id, visit }) => ({
        url: formatString(
          endPoints.conductDataReview.select,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: 'subject_id',
            value: subject_id
          },
          {
            key: 'visit',
            value: visit
          }
        ),
        method: 'GET'
      })
    }),
    getDataReviewcrfSummaryGetAll: builder.query<any, any>({
      query: ({ study_id, subject_id }) => ({
        url: formatString(
          endPoints.conductDataReview.summaryselectAll,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: 'subject_id',
            value: subject_id
          }
        ),
        method: 'GET'
      })
    }),
    getSubjectCRFDetails: builder.query<any, any>({
      query: ({ study_id, parent_id, OID, country, site_id }) => ({
        url: `${formatString(
          endPoints.subjectCRFs.getCRFDetails,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.parent_id,
            value: parent_id
          },
          {
            key: urlKeys.OID,
            value: OID
          },
          {
            key: urlKeys.country,
            value: country
          },
          {
            key: urlKeys.site_id,
            value: site_id
          }
        )}?site_id=${site_id}&country=${country}`,
        method: 'GET'
      })
    }),
    getVisitCRFOIDs: builder.query<any, any>({
      query: ({ study_id }) => ({
        url: formatString(endPoints.subjectCRFs.getVisitCRFOIDs, {
          key: urlKeys.study_id,
          value: study_id
        }),
        method: 'GET'
      })
    }),
    // getAllPatientDetails: builder.query<any, any>({
    //   query: ({ site_id, study_id, country }) => {
    //     return {
    //       url:
    //         `${formatString(endPoints.subjectCRFs.getAllPatientDetails)
    //         }?study_id=${study_id}&site_id=${site_id}&country=${country}&application=CTMS&application_section=CONDUCT`,
    //       method: 'GET'
    //     };
    //   }
    // }),
    getAllPatientDetails: builder.query<any, any>({
      query: ({ site_id, study_id, country, search_scope = 'PATIENT_IDENTIFIER', size = -1 }) => {
        return {
          url: `${formatString(
            endPoints.subjectCRFs.getAllPatientDetails
          )}?search_scope=${search_scope}&study_id=${study_id}&site_id=${site_id}&country=${country}&application=CTMS&application_section=CONDUCT&size=${size}`,

          method: 'GET'
        };
      }
    }),
    getVisitLinkedCRFs: builder.query<any, any>({
      query: ({ site_id, study_id, country, visit_id }) => ({
        url: `${formatString(
          endPoints.subjectCRFs.getVisitLinkedCRFs,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.visit_id,
            value: visit_id
          }
        )}?site_id=${site_id}&country=${country}&application=CTMS&application_section=CONDUCT`,
        method: 'GET'
      })
    }),
    createVerification: builder.mutation<any, any>({
      query: ({ study_id, country, site_id, data }) => ({
        url: `${formatString(
          endPoints.subjectTracking.createVerification,
          {
            key: 'study_id',
            value: study_id
          },
          {
            key: 'country',
            value: country
          },
          {
            key: 'site_id',
            value: site_id
          }
        )}?application=CTMS&application_section=CONDUCT`,
        method: 'POST',
        body: data
      })
    }),
    getAllVerification: builder.mutation<any, any>({
      query: ({ parent_id, record_id, form_oid, site_id, country, study_id, crf_data_id, visit_uuid }) => ({
        url: `${formatString(
          endPoints.subjectTracking.getAllVerification,
          {
            key: 'parent_id',
            value: parent_id
          },
          {
            key: 'record_id',
            value: record_id
          },
          {
            key: 'form_oid',
            value: form_oid
          },
          {
            key: 'visit_uuid',
            value: visit_uuid
          },
          {
            key: 'crf_data_id',
            value: crf_data_id
          }
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=CTMS&application_section=CONDUCT&application_module_section=SUBJECT TRACKING`,
        method: 'GET'
      })
    }),
    getStudyAllCRFVisits: builder.query<any, any>({
      query: ({ site_id, study_id, country, patient_id }) => ({
        url: `${formatString(endPoints.subjectCRFs.getStudyAllCRFVisits, {
          key: urlKeys.study_id,
          value: study_id
        })}?${country ? `country=${country}&` : ''}${site_id ? `site_id=${site_id}&` : ''}${
          patient_id ? `patient_id=${patient_id}&` : ''
        }application=CTMS&application_section=CONDUCT`,
        method: 'GET'
      })
    }),
    sourceDataReviewStatus: builder.mutation<any, any>({
      query: ({ study_id, country, site_id, parent_id, record_id, form_oid, visit_uuid, crf_data_id }) => ({
        url: `${formatString(
          endPoints.subjectTracking.sourceDataReviewStatus,
          {
            key: 'parent_id',
            value: parent_id
          },
          {
            key: 'record_id',
            value: record_id
          },
          {
            key: 'form_oid',
            value: form_oid
          },
          {
            key: 'visit_uuid',
            value: visit_uuid
          },
          {
            key: 'crf_data_id',
            value: crf_data_id
          }
        )}?study_id=${study_id}&country=${country}&site_id=${site_id}&application=CTMS&application_section=CONDUCT`,
        method: 'PUT'
      })
    }),
    selectCRFDataByID: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.subjectCRFs.selectCRFDataByID,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.site_id,
            value: site_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    })
  })
});

export const {
  useLazyGetDataReviewcrfSummaryQuery,
  useLazyGetDataReviewcrfSummaryGetAllQuery,
  useGetVisitCRFOIDsQuery,
  useGetSubjectCRFDetailsQuery,
  useLazyGetVisitCRFOIDsQuery,
  useLazyGetSubjectCRFDetailsQuery,
  useGetAllPatientDetailsQuery,
  useLazyGetVisitLinkedCRFsQuery,
  useCreateVerificationMutation,
  useGetAllVerificationMutation,
  useLazyGetStudyAllCRFVisitsQuery,
  useSourceDataReviewStatusMutation,
  useSelectCRFDataByIDMutation
} = subjectTrackingDetailsAPI;
